module.exports = __webpack_public_path__ + "static/media/bookmyshow.378adb92.jpeg";